import React from 'react';
import { Link as ScrollLink, scroller } from 'react-scroll';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { to: 'hero', label: 'Home', type: 'scroll' },
  { to: 'about', label: 'About', type: 'scroll' },
  { to: '/services', label: 'Services', type: 'route' },
  { to: '/portfolio', label: 'Portfolio', type: 'route' },
];

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Handler for Home/About links when not on homepage
  const handleNav = (section) => (e) => {
    if (location.pathname !== '/') {
      e.preventDefault();
      navigate('/');
      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          offset: -80,
          duration: 500,
        });
      }, 100);
    }
  };

  const underlineClass =
    'after:content-[""] after:block after:h-0.5 after:bg-black after:scale-x-0 hover:after:scale-x-100 after:origin-center after:transition-transform after:duration-300 after:w-full';

  return (
    <nav className="w-full bg-white border-b border-gray-100">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-6 py-4">
        <a href="/" className="flex items-center">
          <img src="/img/logo.png" alt="Logo" className="h-20 w-auto object-contain" />
        </a>
        <div className="flex items-center">
          <div className="flex gap-2 sm:gap-4 md:gap-6">
            {navLinks.map(link => (
              link.type === 'scroll' ? (
                location.pathname === '/' ? (
                  <ScrollLink
                    key={link.to}
                    to={link.to}
                    spy={true}
                    smooth={true}
                    offset={-80}
                    duration={500}
                    className={`relative cursor-pointer text-gray-700 hover:text-black hover:font-bold transition font-medium pb-1 px-2 ${underlineClass}`}
                    isDynamic={true}
                  >
                    {link.label}
                  </ScrollLink>
                ) : (
                  <a
                    key={link.to}
                    href={`/#${link.to}`}
                    onClick={handleNav(link.to)}
                    className={`relative cursor-pointer text-gray-700 hover:text-black hover:font-bold transition font-medium pb-1 px-2 ${underlineClass}`}
                  >
                    {link.label}
                  </a>
                )
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`relative cursor-pointer text-gray-700 hover:text-black hover:font-bold transition font-medium pb-1 px-2 ${underlineClass} ${location.pathname === link.to ? 'text-black font-bold after:scale-x-100' : ''}`}
                >
                  {link.label}
                </Link>
              )
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 